import React from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { queryChartType } from "../schemas/kpi-props.schema";
import { formatCurrency, formatPercent } from "../schemas/dashboard.utils";

interface StatsModalProps<T> {
    isOpen: boolean;
    toggle: () => void;
    title: string;
    data: T[];
    labelField: keyof T;
    valueField: keyof T;
    valueCountField: keyof T;
    queryType: string;
}

export function StatsModal<T>({
    isOpen,
    toggle,
    title,
    data = [],
    labelField,
    valueField,
    valueCountField,
    queryType,
}: Readonly<StatsModalProps<T>>) {
    const totalAmount = data.reduce((acc, curr) => {
        const value = curr[valueField];
        return acc + (typeof value === "number" ? value : 0);
    }, 0);

    const totalCount = data.reduce((acc, curr) => {
        const valueCount = curr[valueCountField];
        return acc + (typeof valueCount === "number" ? valueCount : 0);
    }, 0);

    const isSeverity = queryType === queryChartType.SEVERITY_FREQUENCY;

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="lg" className="prodeseg-dropdown-modal">
            <div className="p-3 position-relative">
                <ModalHeader toggle={toggle} className="border-0">
                    Detalle de {title}
                </ModalHeader>

                <ModalBody>
                    <Table responsive hover>
                        <thead>
                            <tr className="text-muted" style={{ fontSize: "0.8rem" }}>
                                <th>Descripción</th>
                                {isSeverity && <th className="text-right">Frecuencia</th>}
                                <th className="text-right">Monto</th>
                                <th className="text-right">Porcentaje</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(item => {
                                const value = Number(item[valueField]) || 0;
                                const count = Number(item[valueCountField]) || 0;
                                const label = String(item[labelField]);
                                const percentage = totalAmount > 0 ? (value / totalAmount) * 100 : 0;
                                const severityFrequency = label == "SI" ? "SEVERIDAD" : "FRECUENCIA";

                                return (
                                    <tr key={0}>
                                        <td className="text-uppercase">
                                            {queryType === queryChartType.SEVERITY_FREQUENCY
                                                ? severityFrequency
                                                : label}
                                        </td>
                                        {isSeverity && <td className="text-right">{count}</td>}
                                        <td className="text-right">{formatCurrency(value)}</td>
                                        <td className="text-right">{formatPercent(percentage)}</td>
                                    </tr>
                                );
                            })}

                            <tr className={"font-weight-bold"}>
                                <td className="font-weight-bold text-uppercase">Total General</td>
                                {isSeverity && <td className="text-right">{totalCount}</td>}
                                <td className="text-right">{formatCurrency(totalAmount)}</td>
                                <td className="text-right">{totalAmount > 0 ? "100%" : "0%"}</td>
                            </tr>
                        </tbody>
                    </Table>
                </ModalBody>
            </div>
        </Modal>
    );
}